import { Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSelectionListChange } from '@angular/material/list';
import { CreateMerchantMultipleEmployeeComponent } from '../create-merchant-multiple-employee/create-merchant-multiple-employee.component';
import { CreateMerchantSingleEmployeeComponent } from '../create-merchant-single-employee/create-merchant-single-employee.component';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'merchant-employees-selection',
  templateUrl: './merchant-employees-selection.component.html',
  styleUrls: ['./merchant-employees-selection.component.scss',
    '../../../../../../styles/m3-defaul-material-theme.scss']
})
export class MerchantEmployeesSelectionComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private messageService: MessageService
  ){}

  public selectedType: string = 'single';
  public employeeTypeList: any = [
    { header: 'Add a Store Employee',
      body: [
        {title: 'Add individual store employee',
         description: 'Start from scratch by entering the employee\'s details, role, location, and email.',
         value: 'single',
         disabled: false
        },
        {title: 'Add multiple store employees',
         description: 'Quickly add multiple employees by importing a CSV file using the provided Xpress template.',
         value: 'multiple',
         disabled: true
        }
      ],

    },
    { header: 'Add a Web Admin',
      body: [
        {title: 'Add individual Web Admin',
         description: 'Start from scratch by entering the web admin\'s details, role, location, and email.',
         value: 'single',
         disabled: false
        },
        {title: 'Add multiple Web Admins',
         description: 'Quickly add multiple web admins by importing a CSV file using the provided Xpress template.',
         value: 'multiple',
         disabled: true
        }
      ]
    }
  ];

  ngOnInit(): void {
  }

  onSelectionChange(event: MatSelectionListChange): void {
    this.selectedType = event.options[0].value; // Get the value of the selected option
  }

  addEmployee(): void {
    if(this.selectedType === 'single'){
      const dialogRef = this.dialog.open(CreateMerchantSingleEmployeeComponent, {
        width: '60%',
        height: '500px',
        maxHeight: '90vh',
        data: {
          type: this.data.type,
          merchantId: this.data.merchantId,
          storeId: this.data.storeId,
          employee: this.data.employee,
          isEditable: false,
          user: {}
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Employee has been created' });
          this.data.merchantEmployeesComponent.getMerchantEmployees(0);
        }
      });
    } else {
      this.dialog.open(CreateMerchantMultipleEmployeeComponent, {
        width: '40%',
        data: {
          type: this.data.type,
          merchantId: this.data.merchantId,
          merchantEmployeesComponent: this.data.merchantEmployeesComponent
        }
      });
    }
  }
}
